<template>
  <div class="auth-socials">
    <h3 class="auth-socials__title">{{ $tAuth('Sign in with social networks') }}</h3>

    <div class="auth-socials__buttons">
      <a :href="'https://api.jobian.com/auth/social/redirect/facebook?' + queryString" class="auth-socials__btn _facebook">
        <div class="auth-socials__btn-ico-wrap">
          <img src="../assets/img/socials/facebook-blue.svg"
               alt="facebook"
               class="auth-socials__btn-ico"
          >
          <img src="../assets/img/socials/facebook-white.svg"
               alt="facebook"
               class="auth-socials__btn-ico _hover"
          >
        </div>
        <span>{{ $tAuth('Sign in with') }} Facebook</span>
      </a>
      <a :href="'https://api.jobian.com/auth/social/redirect/google?' + queryString"
         class="auth-socials__btn _google">
        <div class="auth-socials__btn-ico-wrap">
          <img src="../assets/img/socials/google.svg"
               alt="google"
               class="auth-socials__btn-ico"
          >
          <img src="../assets/img/socials/google-white.svg"
               alt="google"
               class="auth-socials__btn-ico _hover"
          >
        </div>
        <span>{{ $tAuth('Sign in with') }} Google</span>
      </a>
    </div>

    <div class="auth-socials__comment">
      <BaseSvg name="ico-info"/>
      <span>{{ $tAuth('Sign in with comment') }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AuthSocials",
    props: {
      referralCode: String
    },
    data() {
      return {}
    },
    computed: {
      currentRoleComputed() {
        return this.$store.state.user.userType
      },
      queryString() {
        return `user_type=${this.currentRoleComputed || ''}&referal_code=${this.referralCode || ''}`
      }
    }
  }
</script>

<style>

</style>
